import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { stardardRequest, sagaApiRequest } from '../../utils';
import api from '../../utils/auth';
import { API_BASE } from '../../constants/api.constant'
import {
  DATA_IMPORT_FETCH,
  DATA_IMPORT_REPROCESS,
  DATA_IMPORT_UPLOAD,
} from '../actions';

export function* watchDataImportFetchRequest() {
  const action = DATA_IMPORT_FETCH
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    authProvider: 'firebase',
    requestOptionsFromPayload: (payload) => {
      const page = payload.page ?? 0
      const page_size = payload.page_size ?? 25
      return {
        method: 'post',
        url: `${API_BASE}/data-import/fetch`,
        data: { page, page_size }
      }
    },
    dataPath: 'result',
    dataDefault: { rows: [], total_rows: 0, page_size: 25, page_indx: 0 },
  }));
}

export function* watchDataImportUploadRequest() {
  yield takeEvery(DATA_IMPORT_UPLOAD.REQUEST, function* ({ payload }) {
    const { file, successCb, errorCb } = payload
    const state = yield select()
    const formData = new FormData()
    formData.append('file', file)
    try {
      const response = yield call(sagaApiRequest, api.request({
        method: 'post',
        url: `${API_BASE}/data-import/upload`,
        data: formData,
        headers: {
          Authorization: `Bearer ${state.auth.token}`,
          'Content-Type': 'multipart/form-data',
        },
      }))
      const data = response.result
      yield put(DATA_IMPORT_UPLOAD.successAction(data))
      yield put(DATA_IMPORT_FETCH.requestAction({}))
      if (successCb) {
        successCb(data)
      }
    } catch (error) {
      yield put(DATA_IMPORT_UPLOAD.errorAction(error))
      if (errorCb) {
        errorCb(error)
      }
    }
  })
}

export function* watchDataImportReprocessRequest() {
  const action = DATA_IMPORT_REPROCESS
  yield takeEvery(action.REQUEST, stardardRequest({
    action: action,
    authProvider: 'firebase',
    requestOptionsFromPayload: (payload) => ({
      method: 'post',
      url: `${API_BASE}/data-import/${payload.id}/process`,
      data: {},
    }),
    dataPath: 'result',
    dataDefault: null,
    afterSuccess: function* () {
      yield put(DATA_IMPORT_FETCH.requestAction({}))
    },
  }));
}

export default function* rootSaga() {
  yield all([
    fork(watchDataImportFetchRequest),
    fork(watchDataImportUploadRequest),
    fork(watchDataImportReprocessRequest),
  ]);
}
